import { ActionModal, Button, PageHeader } from 'components';
import {
  Form,
  Input,
  Row,
  Col,
  Divider,
  Select,
  Typography,
  Checkbox,
  Spin,
  Space,
} from 'antd';
import styles from './style.module.scss';
import {
  CheckOutlined,
  EyeOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useSsoUsers } from '../useSsoUsers';
import { useMemo } from 'react';
import { ssoUserItemAdapter } from '../sso-users.adapter';
import FormHelper from '../../../../../helpers/FormHelper';
import Helpers from '../../../../../helpers';
import Radio from '../../../../../components/radio';
import uuid from 'react-uuid';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { getPages } from '../../../../../hooks/useUser';
import useUser from 'hooks/useUser';

const { Option } = Select;

const CompanyCategoryEdit = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    form,
    roles,
    loading,
    chains,
    setSelectedChain,
    companies,
    handleCreateOrUpdate,
    shoppingCenters,
    notifications,
    premisionsModels,
    setRoleId,
    getRolesLodading,
    getCompaniesLoading,
    getSingleLoading,
    setShowRoleModal,
    showRoleModal,
    nextRoleId,
    setNextRoleId,
    setAcceptsChangePremisions,
    approveGroups,
    roleId,
    usedPremissionIds,
    setUsedPremissionIds,
    usedPremissionApproveIds,
    setUsedPremissionApproveIds,
    singleItem,
  } = useSsoUsers(false);
  const { user } = useUser();
  const isSuperAdmin = user?.user?.superadmin || user?.user?.master_admin;

  const onFinish = async (values) => {
    const formattedValues = {
      ...values,
      password_confirmation: values.password,
      confirm_policy: '1',
      username: values.username || values.email,
    };
    await handleCreateOrUpdate(formattedValues);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form
      .validateFields()
      .then(() => {
        form.submit();
      })
      .catch((errorInfo) => {
        console.log('Validation failed:', errorInfo);
        const firstErrorField = errorInfo.errorFields[0]?.name;
        if (firstErrorField) {
          form.scrollToField(firstErrorField);
        }
      });
  };

  const title = isNew ? t('Creare utente') : t('Modifica utente');
  const currentRole = roles.find(
    (i) => i.id === form.getFieldValue('user_role_id'),
  );

  const { pathname = '' } = useLocation();
  const pages = useRecoilValue(getPages);
  const currentPage = useMemo(
    () =>
      pages.find((i) => {
        return (pathname + '/').includes(i.basePath + '/');
      }),
    [pathname, pages],
  );

  const currentSubMenuValue = useMemo(
    () => currentPage?.subLinks?.find((i) => pathname.includes(i.link)),
    [pathname, currentPage],
  );

  const ability = currentSubMenuValue?.ability;


  return (
    <div>
      <PageHeader title={title} />
      {/*<Spin spinning={loading}>*/}
      {/*</Spin>*/}
      <div className={styles.content}>
        <Spin
          spinning={
            loading ||
            getRolesLodading ||
            getCompaniesLoading ||
            getSingleLoading
          }
        >
          <Form
            form={form}
            name='basic'
            wrapperCol={{
              span: 24,
            }}
            initialValues={{
              email: '',
              username: '',
              name: '',
              surname: '',
              password: '',
              password_confirmation: '',
              user_role_id: '',
              sex: '',
              birthday: '',
              phone: '',
              nationality: '',
              country: '',
              city: '',
              address: '',
              zip: '',
              confirm_policy: '',
              confirmation_token: '',
              confirmed_at: '',
              confirmation_sent_at: '',
              chain_id: '',
              send_welcome: false,
              shopping_centers: [],
              notification_ids: [],
              permissions_attributes: [],
            }}
            layout={'vertical'}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
            onFieldsChange={(changedFields) => {
              if (changedFields[0] && changedFields[0].name[0] === 'chain_id') {
                setSelectedChain(changedFields[0].value);
              }
              if (
                changedFields[0] &&
                changedFields[0].name[0] === 'permissions_attributes'
              ) {
                let arr = [];
                form
                  .getFieldValue('permissions_attributes')
                  .filter((i) => !!i)
                  .forEach((i) => {
                    arr.push(i.permission_model_ids);
                    if (typeof i.permission_model_ids === 'string') {
                      arr.push(...JSON.parse(i.permission_model_ids));
                    }
                  });
                setUsedPremissionIds(arr);
              }
              if (
                changedFields[0] &&
                changedFields[0].name[0] === 'permissions_approve_attributes'
              ) {
                let arr = [];
                form
                  .getFieldValue('permissions_approve_attributes')
                  .filter((i) => !!i)
                  .forEach((i) => {
                    arr.push(i.permission_model_ids);
                    if (typeof i.permission_model_ids === 'string') {
                      arr.push(...JSON.parse(i.permission_model_ids));
                    }
                  });
                setUsedPremissionApproveIds(arr);
              }
              if (
                changedFields[0] &&
                changedFields[0].name[0] === 'user_role_id'
              ) {
                if (!isNew) {
                  setShowRoleModal(true);
                } else {
                  setRoleId(changedFields[0].value);
                  setAcceptsChangePremisions(true);
                }
              }
            }}
          >
            <input
              autoComplete={'false'}
              name={'hidden'}
              type={'text'}
              style={{
                display: 'none',
              }}
            />
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label={t('Email')}
                  name='email'
                  rules={[
                    { required: true, message: t('Email obbligatorio') },
                    { type: 'email', message: t('Email non valido') },
                  ]}
                >
                  <Input placeholder={t('Inserisci testo')} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name='username'
                  hidden
                >
                  <Input
                    autoComplete='new-password'
                    placeholder={t('Inserisci testo')}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label={t('Ruolo')}
                  hidden={!isSuperAdmin}
                  name='user_role_id'
                  rules={[{ required: true, message: t('Ruolo obbligatorio') }]}
                >
                  <Select
                    placeholder={t('Ruolo')}
                    onChange={(roleId) => {
                      if (!isNew) {
                        setNextRoleId(roleId);
                        setShowRoleModal(true);
                        return;
                      }

                      form.setFieldsValue({ user_role_id: roleId });
                      setRoleId(roleId);
                    }}
                  >
                    <Option value=''>{t('Ruolo')}</Option>
                    {roles.map((role) => (
                      <Option key={role.id} value={role.id}>
                        {role.title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label={t('Password')} name='password'>
                  <Input.Password placeholder={t('Inserisci la password')} />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label={t('Telefono')} name='phone'>
                  <Input placeholder={t('Telefono')} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={t('Nome')}
                  name='name'
                  rules={[{ required: true, message: t('Nome obbligatorio') }]}
                >
                  <Input placeholder={t('Inserisci testo')} />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label={t('Cognome')} name='surname'>
                  <Input placeholder={t('Inserisci testo')} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name={'chain_id'} label={t('Catena')}>
                  <Select
                    disabled={currentRole?.is_admin}
                    {...Helpers.addSearchProps()}
                    placeholder={t('Selezioni opzione')}
                  >
                    <Option value=''>{t('Selezioni opzione')}</Option>
                    {chains.map((chain) => (
                      <Option value={chain.id} key={chain.id}>
                        {chain.title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            
              <>
                
                  <Row style={{ display: currentRole?.is_admin ? 'block' : 'none' }} gutter={24}>
                    <Col span={24}>
                      <Typography.Title level={3}>
                        {t('Outlet Village')}
                      </Typography.Title>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        className={styles.checkbox}
                        name='shopping_centers'
                        rules={currentRole?.is_admin ? [
                          { required: true, message: t('Outlet obbligatorio') },
                        ]: []}
                      >
                        <Checkbox.Group>
                          {shoppingCenters.map((company) => (
                            <Checkbox value={company.id} key={company.id}>
                              {company.title}
                            </Checkbox>
                          ))}
                        </Checkbox.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                
                
                  <Row style={{ display: !currentRole?.is_admin ? 'block' : 'none' }} gutter={24}>
                    <Col span={24}>
                      <Typography.Title level={3}>
                        {t('INSEGNE')}
                      </Typography.Title>
                    </Col>
                    <Col span={24}>
                      <Form.Item className={styles.checkbox} name='companies'>
                        <Checkbox.Group>
                          {companies.map((company) => (
                            <Checkbox value={company.id} key={company.id}>
                              {company.title} ({company?.shopping_center?.title}
                              )
                            </Checkbox>
                          ))}
                        </Checkbox.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                
              </>
            
            
              <Row style={{ display: ability?.can_notification ? 'block' : 'none' }} gutter={24}>
                <Col span={24}>
                  <Typography.Title level={3}>
                    {t('Gruppi notifiche')}
                  </Typography.Title>
                </Col>
                <Col span={24}>
                  <Form.Item
                    className={styles.checkbox}
                    name='notification_ids'
                  >
                    <Checkbox.Group>
                      {notifications.map((company) => (
                        <Checkbox value={company.id} key={company.id}>
                          {company.title}
                        </Checkbox>
                      ))}
                    </Checkbox.Group>
                  </Form.Item>
                </Col>
              </Row>
            
            <Divider />

              <Row style={{ display: ability?.can_permission ? 'block' : 'none' }} className={styles.presetPermessi}>
                <Col span={24}>
                  <Typography.Title level={3}>{t('Permessi')}</Typography.Title>
                </Col>
                <Col span={24}>
                  <Form.List name='permissions_attributes'>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }, index) => {
                          const hasTitle = form.getFieldValue([
                            'permissions_attributes',
                            name,
                            'mainTitle',
                          ]);
                          return (
                            <>
                              <Row>
                                <Col span={24}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'mainTitle']}
                                    hidden={!hasTitle}
                                  >
                                    <Input
                                      bordered={false}
                                      disabled
                                      className={styles.inputTitle}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Space
                                key={key}
                                style={{
                                  display: 'flex',
                                  marginBottom: 8,
                                }}
                                align='center'
                              >
                                <Form.Item
                                  {...restField}
                                  name={[name, 'access_type']}
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        'La selezione del permesso è obbligatoria',
                                    },
                                  ]}
                                >
                                  <Radio.Group>
                                    <Radio value={'read'}>{t('Read')}</Radio>
                                    <Radio value={'create'}>
                                      {t('Read and write')}
                                    </Radio>
                                    <Radio value={'write'}>
                                      {t('Read and update')}
                                    </Radio>
                                    <Radio value={'deny'}>{t('Deny')}</Radio>
                                  </Radio.Group>
                                </Form.Item>
                                <Form.Item
                                  label={t('Preset permessi')}
                                  {...restField}
                                  name={[name, 'permission_model_ids']}
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        'La selezione del preset è obbligatoria',
                                    },
                                  ]}
                                >
                                  <Select
                                    style={{ width: '400px' }}
                                    placeholder={t('Selezioni opzione')}
                                  >
                                    <Select.Option value={''}>
                                      {t('Selezioni opzione')}.
                                    </Select.Option>
                                    {premisionsModels.map((item) => {
                                      const arr = [];
                                      arr.push(
                                        <Select.Option
                                          key={uuid()}
                                          value={JSON.stringify(
                                            item.permission_models.map(
                                              (i) => i.id,
                                            ),
                                          )}
                                          disabled={usedPremissionIds.includes(
                                            JSON.stringify(
                                              item.permission_models.map(
                                                (i) => i.id,
                                              ),
                                            ),
                                          )}
                                        >
                                          <Typography.Title level={5} strong>
                                            {item.title}
                                          </Typography.Title>
                                        </Select.Option>,
                                      );
                                      item.permission_models.forEach((i) => {
                                        arr.push(
                                          <Select.Option
                                            disabled={usedPremissionIds.includes(
                                              i.id,
                                            )}
                                            key={uuid()}
                                            value={i.id}
                                          >
                                            <span style={{ marginLeft: 16 }}>
                                              {i.title}
                                            </span>
                                          </Select.Option>,
                                        );
                                      });
                                      return arr;
                                    })}
                                  </Select>
                                </Form.Item>
                                <MinusCircleOutlined
                                  onClick={() => {
                                    remove(name);
                                  }}
                                />
                              </Space>
                            </>
                          );
                        })}
                        <Form.Item>
                          <Button
                            width={250}
                            onClick={() => add()}
                            icon={<PlusOutlined />}
                          >
                            {t('Aggiungi modulo')}
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>
                </Col>
              </Row>
            
            <br />
            
              <Row style={{ display: ability?.can_permission ? 'block' : 'none' }} className={styles.presetPermessi}>
                <Col span={24}>
                  <Typography.Title level={3}>
                    {t('Approvazioni')}
                  </Typography.Title>
                </Col>
                <Col span={24}>
                  <Form.List name='permissions_approve_attributes'>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }, index) => {
                          const hasTitle = form.getFieldValue([
                            'permissions_approve_attributes',
                            name,
                            'mainTitle',
                          ]);
                          return (
                            <>
                              <Row>
                                <Col span={24}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'mainTitle']}
                                    hidden={!hasTitle}
                                  >
                                    <Input
                                      bordered={false}
                                      disabled
                                      className={styles.inputTitle}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Space
                                key={key}
                                style={{
                                  display: 'flex',
                                  marginBottom: 8,
                                }}
                                align='center'
                              >
                                <Form.Item
                                  {...restField}
                                  name={[name, 'approve']}
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        'La selezione del permesso è obbligatoria',
                                    },
                                  ]}
                                >
                                  <Radio.Group>
                                    <Radio value={'step1'}>{t('Step 1')}</Radio>
                                    <Radio value={'step2'}>{t('Step 2')}</Radio>
                                  </Radio.Group>
                                </Form.Item>
                                <Form.Item
                                  label={t('Approvazioni')}
                                  {...restField}
                                  name={[name, 'permission_model_ids']}
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        'La selezione del preset è obbligatoria',
                                    },
                                  ]}
                                >
                                  <Select
                                    style={{ width: '300px' }}
                                    placeholder={t('Selezioni opzione')}
                                  >
                                    <Select.Option value={''}>
                                      {t('Selezioni opzione')}.
                                    </Select.Option>
                                    {approveGroups.map((item) => {
                                      const arr = [];
                                      arr.push(
                                        <Select.Option
                                          key={uuid()}
                                          value={JSON.stringify(
                                            item.permission_models.map(
                                              (i) => i.id,
                                            ),
                                          )}
                                          disabled={usedPremissionApproveIds.includes(
                                            JSON.stringify(
                                              item.permission_models.map(
                                                (i) => i.id,
                                              ),
                                            ),
                                          )}
                                        >
                                          <Typography.Title level={5} strong>
                                            {item.title}
                                          </Typography.Title>
                                        </Select.Option>,
                                      );
                                      item.permission_models.forEach((i) => {
                                        arr.push(
                                          <Select.Option
                                            disabled={usedPremissionApproveIds.includes(
                                              i.id,
                                            )}
                                            key={uuid()}
                                            value={i.id}
                                          >
                                            <span style={{ marginLeft: 16 }}>
                                              {i.title}
                                            </span>
                                          </Select.Option>,
                                        );
                                      });
                                      return arr;
                                    })}
                                  </Select>
                                </Form.Item>
                                <MinusCircleOutlined
                                  onClick={() => {
                                    remove(name);
                                  }}
                                />
                              </Space>
                            </>
                          );
                        })}
                        <Form.Item>
                          <Button
                            width={250}
                            onClick={() => add()}
                            icon={<PlusOutlined />}
                          >
                            {t('Aggiungi modulo')}
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>
                </Col>
              </Row>
            
            <Divider />
            <Row gutter={1}>
              <Col span={24}>
                <Form.Item
                  className={styles.checkbox}
                  name='send_welcome'
                  valuePropName='checked'
                >
                  <Checkbox>{t('Manda benvenuto via mail')}</Checkbox>
                </Form.Item>
                <br />
              </Col>
            </Row>
          </Form>
        </Spin>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
      {showRoleModal && (
        <ActionModal
          title={t('Attenzione i preset esistenti verrano resettati')}
          description={''}
          yesBtnText={t('Ok')}
          noBtnText={t('Cancella')}
          onClickOk={() => {
            setAcceptsChangePremisions(true);
            form.setFieldsValue({ user_role_id: nextRoleId });
            setRoleId(nextRoleId);
            setShowRoleModal(false);
          }}
          onCancel={() => setShowRoleModal(false)}
        />
      )}
    </div>
  );
};

export default CompanyCategoryEdit;
